/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react'
import Balloon from './Balloon'

const WORDS = ['Hello', 'Привіт', 'Ciao', 'Hola', 'Bonjour', 'Hallo', 'Cześć', 'こんにちは']

// ~1.1s greeting: one balloon cutting from language to language, then a clean cut to the page.
const Preloader = ({ onDone }) => {
  const [i, setI] = useState(0)

  useEffect(() => {
    if (i === WORDS.length - 1) {
      const id = setTimeout(onDone, 150)
      return () => clearTimeout(id)
    }
    const id = setTimeout(() => setI(i + 1), i === 0 ? 350 : 100)
    return () => clearTimeout(id)
  }, [i, onDone])

  return (
    <div aria-hidden='true' className='fixed inset-0 z-50 grid place-items-center bg-sky'>
      <Balloon>
        <p className='min-w-[6ch] text-center font-display uppercase text-h2'>{WORDS[i]}!</p>
      </Balloon>
    </div>
  )
}

export default Preloader
